// extracted by mini-css-extract-plugin
module.exports = {"div":"Dashboard_div__1VCB6","container":"Dashboard_container__BH_Ca"};